export const APP_START = 'boilerplate/app_start'
export const BULK_EDITOR_PANE_TOGGLE = 'BULK_EDITOR_PANE_TOGGLE'
export const UPDATE_DATA_SOURCE = 'UPDATE_DATA_SOURCE'
export const SET_SPEND_DURATION = 'SET_SPEND_DURATION'